<div class="pdf-overlay open" #pdfOverlay>
    <div class="backdrop"></div>
    <div class="pdf-header">
      <div class="pdf-title">{{ pdfName }}</div>
      <div class="pdf-controls">
        <button (click)="zoomOut()">−</button>
        <button (click)="zoomIn()">＋</button>
        <button (click)="close()">✕</button>
      </div>
    </div>
    <div #pdfContainer class="pdf-container"></div>
  </div>

  @if(isLoading){
    <app-loader></app-loader>
  }